import React from "react";
import ScrollDown from "../scroll-down/scroll-down.component";
import "./my-carousal.styles.css";
import MyProfilePic from "../profile-pic/my-profile-pic.component";
import MyTitleMessage from "../title-message/title-message.component";
import CursorSpotlight from "../cursor-spotlight/CursorSpotlight";

const MyCarousal = () => {
  return (
    <div id="home">
      <CursorSpotlight
        color="rgba(34, 211, 238, 0.22)"
        size={700}
      />
      <div className="hero-glow" aria-hidden="true" />
      <div className="picCarousal">
        <MyProfilePic />
        <MyTitleMessage />
      </div>
      <ScrollDown />
    </div>
  );
};

export default MyCarousal;
